import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";
import { useEntryTarget } from "@/hooks/useUserSystems";
import { isNativePlatform } from "@/lib/platform";
import FleetLandingPage from "./fleet/LandingPage";

const Index = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const { data: entryTarget, isLoading: entryLoading } = useEntryTarget(user?.id);

  // Early return for mobile platforms - show loading instead of landing page
  if (isNativePlatform()) {
    useEffect(() => {
      console.log('Mobile app detected, redirecting to /driver/select');
      navigate('/driver/select', { replace: true });
    }, [navigate]);

    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p>Carregando...</p>
        </div>
      </div>
    );
  }

  useEffect(() => {
    const currentPath = window.location.pathname;
    
    // If user is authenticated and we have their entry target, redirect
    if (user && entryTarget?.basePath && entryTarget.basePath !== '/' && !entryLoading) {
      // Only navigate if we're not already at the target path and not on a specific route
      if (currentPath === '/' || currentPath === '/index') {
        console.log('Index redirecting from', currentPath, 'to', entryTarget.basePath);
        navigate(entryTarget.basePath, { replace: true });
      }
    }
  }, [user, entryTarget, entryLoading, navigate]);

  // Show loading for authenticated users while determining redirect
  if (user && (loading || entryLoading)) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p>Redirecionando...</p>
        </div>
      </div>
    );
  }

  return <FleetLandingPage />;
};

export default Index;
